/* @flow */
import * as React from 'react';
import { Route } from 'react-router-dom';
import { translate } from 'react-i18next';

import { Title } from 'common/components/common';
import withRouteTracker from 'common/middleware/RouteTracker';
import SectionWrap from 'common/components/common/SectionWrap';
import Products from 'common/enums/Product';
import { lazy } from 'common/modules/mfe';
import {
    withRoutePermissionCheck,
    RoleOperationEnum
} from 'common/modules/rbac';

import { type GetRoutesFn } from './types';

const OrchestrationContainer = lazy(() =>
    import('orchestrator-app/OrchestrationContainer')
);

const OrchestrationContainerSection = withRouteTracker(
    withRoutePermissionCheck(
        translate()(props => (
            <SectionWrap>
                <Title i18nKey="shipFlexDashboard" />
                <OrchestrationContainer {...props} />
            </SectionWrap>
        )),
        RoleOperationEnum.PARCEL_ORCHESTRATION_VIEW_QUOTES
    ),
    Products.ORCHESTRATION
);

const getRoutes: GetRoutesFn = ({ match, visibleSections }) => {
    return (
        visibleSections.showOrchestrationSection && (
            <Route
                path={`${match.path}/shipflex`}
                component={OrchestrationContainerSection}
            />
        )
    );
};

export default getRoutes;
